import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);
const lazy = new LazyLoad();

export function partnersSlider() {

    let partners_options = {
        speed: 600,
        loop: true,
        autoHeight: false,
        height:150,
        watchOverflow: true,
        spaceBetween:20,
        on: {
            init: function () {
                lazy.update()
            },
            slideChange: function (e) {
                lazy.update()
            },
        },
        pagination: {
            el: "#partners-slider .partners-swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '" ><svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><circle stroke-width="3" cx="4" cy="4" r="4"></circle></svg></span>';
            },
        },

        navigation: {
            nextEl: '#partners-slider .js-slider-next',
            prevEl: '#partners-slider .js-slider-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            767: {
                slidesPerView: 5,
                slidesPerGroup: 5,
            },
            1600: {
                loop: false,
                slidesPerView: 5,
                slidesPerGroup: 5,
            }
        }
    };

    let partners = new Swiper("#partners-slider .swiper-container", partners_options);
}
